import { connect, ConnectedProps } from 'react-redux';

import { MessageType } from 'dashboard/lib/interfaces/Message';
import { ExporterFileType } from 'dashboard/models/exporter';
import { ProductFeatureName } from 'dashboard/models/organization';
import { showMessage } from 'dashboard/redux/actions/messages';
import { getAdjustedFilters, getDynamicFilters } from 'dashboard/redux/selectors/metrics-inquiry';
import { getAllTemplates, getInquiryTags } from 'dashboard/redux/selectors/organization';
import { RootState } from 'dashboard/redux/store';
import { loadExporterMetricsInquiry } from 'dashboard/redux/thunk-actions/metrics-inquiry';
import DashboardInquiryAnalyticsView from 'dashboard/views/DashboardInquiryAnalyticsView';
import useProductFeature from 'lib/hooks/useProductFeature';

const DashboardInquiryAnalyticsRoute = (props: PropsFromRedux) => {
  const productFeatureIsDisabled = !useProductFeature(ProductFeatureName.InquiriesAnalytics);

  const {
    currentEnvironment,
    lastQueryFilters,
    volume,
    queriedAt,
    filters,
    templates,
    dynamicFilters,
    inquiryTags,
  } = props;

  const handleExportData = async (fileType: ExporterFileType) => {
    try {
      await props.loadExporterMetricsInquiry({
        currentEnvironment,
        filters: lastQueryFilters.overview,
        sortParams: {
          sort: 'created_timestamp',
          shouldSortDescending: true,
        },
        fileType: fileType,
      });
      props.showMessage('You will receive an email when your export is ready.', MessageType.Notice);
    } catch {
      props.showMessage('Failed to create export, please try again.', MessageType.Failure);
    }
  };

  return (
    <DashboardInquiryAnalyticsView
      currentEnvironment={currentEnvironment}
      productFeatureIsDisabled={productFeatureIsDisabled}
      filters={filters}
      lastQueryFilters={lastQueryFilters}
      templates={templates}
      inquiryTags={inquiryTags}
      dynamicFilters={dynamicFilters}
      handleExportData={handleExportData}
      volume={volume}
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      queriedAt={queriedAt.volume}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  currentEnvironment: state.currentEnvironment.currentEnvironment,
  lastQueryFilters: state.metricsInquiry.lastQueryFilters,
  filters: getAdjustedFilters(state),
  templates: getAllTemplates(state),
  inquiryTags: getInquiryTags(state),
  dynamicFilters: getDynamicFilters(state),
  volume: state.metricsInquiry.volume,
  queriedAt: state.metricsInquiry.queriedAt,
});

const mapDispatchToProps = {
  loadExporterMetricsInquiry,
  showMessage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardInquiryAnalyticsRoute);
